/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/no-styled */
/* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/no-styled */
/* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const AIAnswerSearchBorder: ComponentType<
	{
		isLoading: boolean;
		isStreaming: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
> = styled.div<{
	isLoading: boolean;
	isStreaming: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>(({ isLoading, isStreaming }) => ({
	display: 'flex',
	flexDirection: 'column',
	position: 'relative',
	borderRadius: `${token('radius.small', '4px')}`,
	border: `${token('border.width')} solid ${token('color.border')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: '0',
	boxSizing: 'border-box',
	overflow: 'hidden',
	zIndex: 3,
	'&::before': {
		content: "''",
		width: '1000vw',
		height: '1000vh',
		left: 'calc(-500vw + 50%)',
		top: 'calc(-500vh + 50%)',
		position: 'absolute',
		zIndex: -2,
		borderRadius: `${token('radius.small', '4px')}`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		background:
			isLoading || isStreaming
				? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)'
				: token('elevation.surface.overlay'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		animation: isLoading || isStreaming ? 'rotate 3s infinite linear' : 'rotate-end 3s 1 linear',
		filter: 'blur(25px)',
	},
	'&::after': {
		content: "''",
		width: `100% - ${token('space.050')}`,
		height: `100% - ${token('space.050')}`,
		inset: '1px',
		position: 'absolute',
		zIndex: -1,
		borderRadius: `${token('radius.small', '4px')}`,
		backgroundColor: token('elevation.surface.overlay'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'@keyframes rotate': {
		from: {
			transform: 'rotate(0deg)',
		},
		to: {
			transform: 'rotate(360deg)',
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'@keyframes rotate-end': {
		from: {
			transform: 'rotate(0deg)',
			background:
				'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)',
		},
		to: {
			transform: 'rotate(360deg)',
			background:
				'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)',
		},
	},
}));
